export default "__VITE_ASSET__DKzIuVod__"